import React from 'react';
import {
  Button,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@roger/ui-components';
import { Plus, X } from 'lucide-react';
import type { DiagnosisCodeListProps } from '../types';

const qualifierCodeOptions = [
  { value: 'ABF', label: 'ABF - ICD-10-CM Diagnosis' },
  { value: 'BF', label: 'BF - Diagnosis' },
];

const DiagnosisCodeList: React.FC<DiagnosisCodeListProps> = ({
  diagnosisList,
  onChange,
  onAdd,
  onRemove,
  title = 'Other Diagnosis Codes',
}) => {
  return (
    <div className='space-y-4'>
      <div className='flex items-center justify-between'>
        <h4 className='text-sm font-medium'>{title}</h4>
        <Button type='button' onClick={onAdd} size='sm' variant='outline'>
          <Plus className='w-4 h-4' />
          Add Diagnosis
        </Button>
      </div>

      {diagnosisList.map((diagnosis, index) => (
        <div
          key={index}
          className='flex items-end space-x-2 p-3 border rounded'
        >
          <div className='flex-1'>
            <label className='block text-sm font-medium mb-1'>
              Diagnosis Code
            </label>
            <Input
              value={diagnosis[0]?.otherDiagnosisCode || ''}
              onChange={e =>
                onChange(index, 'otherDiagnosisCode', e.target.value)
              }
              placeholder='ICD-10 code'
            />
          </div>

          <div className='flex-1'>
            <label className='block text-sm font-medium mb-1'>
              Qualifier Code
            </label>
            <Select
              value={diagnosis[0]?.qualifierCode || ''}
              onValueChange={value => onChange(index, 'qualifierCode', value)}
            >
              <SelectTrigger>
                <SelectValue placeholder='Select qualifier' />
              </SelectTrigger>
              <SelectContent>
                {qualifierCodeOptions.map(option => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <Button
            type='button'
            onClick={() => onRemove(index)}
            size='sm'
            variant='outline'
            className='flex-shrink-0'
          >
            <X className='w-4 h-4' />
          </Button>
        </div>
      ))}

      {diagnosisList.length === 0 && (
        <div className='text-center py-4 text-gray-700'>
          No diagnosis codes added. Click "Add Diagnosis" to get started.
        </div>
      )}
    </div>
  );
};

export default DiagnosisCodeList;
